var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.detail
    ? _c(
        "div",
        { staticClass: "xinfang-detail" },
        [
          _c(
            "div",
            { staticClass: "swiper-outer" },
            [
              _c(
                "swiper",
                {
                  ref: "mySwiper",
                  staticClass: "swiper",
                  attrs: {
                    options: _vm.swiperOption,
                    "not-next-tick": _vm.notNextTick,
                  },
                },
                [
                  _vm._l(_vm.detail.fy_list, function (pic) {
                    return _c("swiper-slide", { key: pic.pic_path }, [
                      _c("img", {
                        staticClass: "swiper-image",
                        attrs: { src: pic.pic_path },
                        on: {
                          click: function ($event) {
                            return _vm.showImagePreview(pic.pic_path, "pic")
                          },
                        },
                      }),
                    ])
                  }),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "swiper-pagination",
                    attrs: { slot: "pagination" },
                    slot: "pagination",
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _vm.detail.vr_url
                ? _c("img", {
                    staticClass: "vr",
                    attrs: { src: require("../../images/icon-vr.png") },
                    on: {
                      click: function ($event) {
                        return _vm.gotoVr(_vm.detail.vr_url)
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.detail.vedio_url
                ? _c("img", {
                    staticClass: "video",
                    attrs: { src: require("../../images/icon-video.png") },
                    on: {
                      click: function ($event) {
                        return _vm.gotoVideo(_vm.detail.vedio_url)
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("img", {
                staticClass: "images",
                attrs: { src: require("../../images/icon-imgs.png") },
                on: {
                  click: function ($event) {
                    return _vm.gotoImages(_vm.detail.vr_addr)
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.detail.xmmc)),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "md" }, [
            _vm._v("项目卖点：" + _vm._s(_vm.detail.xmmd)),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "tags" },
            [
              _vm.detail.vedio_url
                ? _c("span", { staticClass: "tag red" }, [_vm._v("视频讲盘")])
                : _vm._e(),
              _vm._v(" "),
              _vm.detail.vr_url
                ? _c("span", { staticClass: "tag blue" }, [_vm._v("VR看房")])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.detail.xmbq.split(","), function (tag) {
                return _c("span", { key: tag, staticClass: "tag" }, [
                  _vm._v(_vm._s(tag)),
                ])
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "info" }, [
            _c("span", { staticClass: "short" }, [
              _c("span", { staticClass: "label" }, [_vm._v("均价：")]),
              _vm._v(_vm._s(_vm.detail.xmjj) + "元/m²"),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "short" }, [
              _c("span", { staticClass: "label" }, [_vm._v("总价：")]),
              _vm._v(_vm._s(_vm.detail.xmzj) + "万元/套"),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "short" }, [
              _c("span", { staticClass: "label" }, [_vm._v("用途：")]),
              _vm._v(_vm._s(_vm.detail.yt)),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "short" }, [
              _c("span", { staticClass: "label" }, [_vm._v("开盘：")]),
              _vm._v(_vm._s(_vm.detail.kpsj)),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "short" }, [
              _c("span", { staticClass: "label" }, [_vm._v("户型：")]),
              _vm._v(_vm._s(_vm.detail.hx)),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "short" }, [
              _c("span", { staticClass: "label" }, [_vm._v("建面：")]),
              _vm._v(_vm._s(_vm.detail.jzmj) + "m²"),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "short" }, [
              _c("span", { staticClass: "label" }, [_vm._v("物业：")]),
              _vm._v(_vm._s(_vm.detail.wy)),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "short" }, [
              _c("span", { staticClass: "label" }, [_vm._v("装修：")]),
              _vm._v(_vm._s(_vm.detail.zx)),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "short" }, [
              _c("span", { staticClass: "label" }, [_vm._v("建筑：")]),
              _vm._v(_vm._s(_vm.detail.jzlx)),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "short" }, [
              _c("span", { staticClass: "label" }, [_vm._v("产权：")]),
              _vm._v(_vm._s(_vm.detail.cq)),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "xmms" }, [
            _c("div", { staticClass: "label" }, [_vm._v("项目描述：")]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _vm._v(_vm._s(_vm.detail.xmms)),
            ]),
          ]),
          _vm._v(" "),
          _vm.isManager
            ? _c("div", { staticClass: "kfs-name" }, [
                _c("span", { staticClass: "label" }, [_vm._v("开发商：")]),
                _vm._v(_vm._s(_vm.detail.kfs)),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.isManager
            ? _c("div", { staticClass: "lp-address" }, [
                _c("span", { staticClass: "label" }, [_vm._v("楼盘地址：")]),
                _vm._v(" "),
                _c("span", { staticClass: "content" }, [
                  _vm._v(_vm._s(_vm.detail.lpdz)),
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "guide", on: { click: _vm.openGuide } },
                  [_vm._v("带我去")]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.isManager
            ? _c("div", { ref: "map", staticClass: "map" })
            : _vm._e(),
          _vm._v(" "),
          _vm.xiaoshou
            ? _c("div", { staticClass: "info" }, [
                _c("div", { staticClass: "info-lable" }, [_vm._v("销售信息")]),
                _vm._v(" "),
                _c("span", { staticClass: "long" }, [
                  _c("span", { staticClass: "label" }, [_vm._v("销售状态：")]),
                  _vm._v(_vm._s(_vm.xiaoshou.xszt)),
                ]),
                _vm._v(" "),
                _vm.isManager
                  ? _c("span", { staticClass: "long" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("售楼地址："),
                      ]),
                      _vm._v(_vm._s(_vm.xiaoshou.sldz)),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("span", { staticClass: "long" }, [
                  _c("span", { staticClass: "label" }, [_vm._v("在售楼栋：")]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.selectLoudong,
                          expression: "selectLoudong",
                        },
                      ],
                      attrs: { placeholder: "请选择楼栋" },
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.selectLoudong = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                      },
                    },
                    _vm._l(_vm.detail.loudong_list, function (loudong) {
                      return _c(
                        "option",
                        { domProps: { value: loudong.ldmc } },
                        [_vm._v(_vm._s(loudong.ldmc))]
                      )
                    }),
                    0
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.detail.loudong_list, function (loudong) {
            return loudong.ldmc == _vm.selectLoudong
              ? _c(
                  "div",
                  { staticClass: "loudong" },
                  [
                    _c("div", { staticClass: "loudong-title" }, [
                      _vm._v(_vm._s(loudong.ldmc)),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "info" }, [
                      _c("span", { staticClass: "short" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("开盘："),
                        ]),
                        _vm._v(_vm._s(loudong.kpsj)),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "short" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("交房："),
                        ]),
                        _vm._v(_vm._s(loudong.jfsj)),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "short" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("装修："),
                        ]),
                        _vm._v(_vm._s(loudong.zx)),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "short" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("单元："),
                        ]),
                        _vm._v(_vm._s(loudong.dy) + "单元"),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "short" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("层数："),
                        ]),
                        _vm._v(_vm._s(loudong.cs) + "层"),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "short" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("户数："),
                        ]),
                        _vm._v(_vm._s(loudong.hs) + "户"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "hx-title" }, [
                      _vm._v("【" + _vm._s(loudong.ldmc) + "】户型"),
                    ]),
                    _vm._v(" "),
                    _vm._l(loudong.hx_list, function (hx) {
                      return _c("div", { staticClass: "hx-item" }, [
                        hx.hxt_pic && hx.hxt_pic.length > 0
                          ? _c("img", {
                              staticClass: "hx-preview",
                              attrs: {
                                src:
                                  "http://wx.beijinghome.cc/Contract/swfupload/view/pic.jsp?id=" +
                                  hx.hxt_pic[0].pic_path,
                              },
                            })
                          : _c("img", {
                              staticClass: "hx-preview",
                              attrs: {
                                src: require("../../images/preview-defalt-new.png"),
                              },
                            }),
                        _vm._v(" "),
                        _c("div", { staticClass: "hx-info" }, [
                          _c("div", { staticClass: "hx-hx" }, [
                            _vm._v(_vm._s(hx.hx)),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "hx-other" }, [
                            _vm._v(
                              "建面：" +
                                _vm._s(hx.jzmj) +
                                "m²  朝向：" +
                                _vm._s(hx.cx)
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "hx-tags" },
                            _vm._l(hx.xmbq.split(","), function (tag) {
                              return _c("span", { key: tag }, [
                                _vm._v(_vm._s(tag)),
                              ])
                            }),
                            0
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "hxms" }, [
                          _vm._v("户型描述：" + _vm._s(hx.hxms)),
                        ]),
                      ])
                    }),
                  ],
                  2
                )
              : _vm._e()
          }),
          _vm._v(" "),
          _vm.xiaoqu
            ? _c("div", { staticClass: "info" }, [
                _c("div", { staticClass: "info-lable" }, [_vm._v("小区概况")]),
                _vm._v(" "),
                _c("span", { staticClass: "short" }, [
                  _c("span", { staticClass: "label" }, [_vm._v("占地面积：")]),
                  _vm._v(_vm._s(_vm.xiaoqu.zdmj) + "m²"),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "short" }, [
                  _c("span", { staticClass: "label" }, [_vm._v("建筑面积：")]),
                  _vm._v(_vm._s(_vm.xiaoqu.jzmj) + "m²"),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "short" }, [
                  _c("span", { staticClass: "label" }, [_vm._v("容积率：")]),
                  _vm._v(_vm._s(_vm.xiaoqu.rjl)),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "short" }, [
                  _c("span", { staticClass: "label" }, [_vm._v("绿化率：")]),
                  _vm._v(_vm._s(_vm.xiaoqu.lhl)),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "long" }, [
                  _c("span", { staticClass: "label" }, [_vm._v("规划车位：")]),
                  _vm._v(
                    "地下" +
                      _vm._s(_vm.xiaoqu.dxcw) +
                      "个，地上" +
                      _vm._s(_vm.xiaoqu.dscw) +
                      "个"
                  ),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "long" }, [
                  _c("span", { staticClass: "label" }, [_vm._v("车位配比：")]),
                  _vm._v(_vm._s(_vm.xiaoqu.cwpb)),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "short" }, [
                  _c("span", { staticClass: "label" }, [_vm._v("规划楼栋：")]),
                  _vm._v(_vm._s(_vm.xiaoqu.ghld) + "栋"),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "short" }, [
                  _c("span", { staticClass: "label" }, [_vm._v("规划户数：")]),
                  _vm._v(_vm._s(_vm.xiaoqu.ghhs) + "户"),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "short" }, [
                  _c("span", { staticClass: "label" }, [_vm._v("物业费用：")]),
                  _vm._v(_vm._s(_vm.xiaoqu.wyf) + "元/m²/月"),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "short" }, [
                  _c("span", { staticClass: "label" }, [_vm._v("供暖方式：")]),
                  _vm._v(_vm._s(_vm.xiaoqu.gnfs)),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "short" }, [
                  _c("span", { staticClass: "label" }, [_vm._v("供水：")]),
                  _vm._v(_vm._s(_vm.xiaoqu.gs)),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "short" }, [
                  _c("span", { staticClass: "label" }, [_vm._v("供电：")]),
                  _vm._v(_vm._s(_vm.xiaoqu.gd)),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.detail.xukezheng_list
            ? _c(
                "div",
                { staticClass: "info" },
                [
                  _c("div", { staticClass: "info-lable" }, [
                    _vm._v("预售许可证"),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.detail.xukezheng_list, function (xukezheng) {
                    return [
                      _c("span", { staticClass: "long" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("预售证："),
                        ]),
                        _vm._v(_vm._s(xukezheng.ysz)),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "long" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("发证时间："),
                        ]),
                        _vm._v(_vm._s(xukezheng.fzsj)),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "long" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("绑定楼栋："),
                        ]),
                        _vm._v(_vm._s(xukezheng.bdld)),
                      ]),
                    ]
                  }),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isManager
            ? _c("div", { staticClass: "btn-group" }, [
                _c(
                  "div",
                  { staticClass: "btn-item", on: { click: _vm.goToShare } },
                  [_vm._v("分享记录")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "btn-item", on: { click: _vm.goToBaoBei } },
                  [_vm._v("联系报备")]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "btn-share",
              on: {
                click: function ($event) {
                  _vm.showShareCover = true
                },
              },
            },
            [_vm._v("分享房源")]
          ),
          _vm._v(" "),
          _vm.showShareCover
            ? _c(
                "div",
                {
                  staticClass: "share-cover",
                  on: {
                    click: function ($event) {
                      _vm.showShareCover = false
                    },
                  },
                },
                [
                  _c("img", {
                    attrs: { src: require("../../images/share-it.png") },
                  }),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.detail.status == "00" && !_vm.isManager
            ? _c("div", { staticClass: "no-publish" }, [
                _vm._v("\n    亲！房源已失效～～～\n  "),
              ])
            : _vm._e(),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }